import React from "react";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";

import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import NoteIcon from "@material-ui/icons/Note";
import EventIcon from "@material-ui/icons/Event";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import ScheduleIcon from "@material-ui/icons/Schedule";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";

const typeConfig = {
  ticket: { label: "Atendimento", color: "#25D366", Icon: ChatBubbleOutlineIcon },
  note: { label: "Nota", color: "#FB8C00", Icon: NoteIcon },
  appointment: { label: "Agendamento", color: "#3F51B5", Icon: EventIcon },
  transaction: { label: "Financeiro", color: "#00897B", Icon: AttachMoneyIcon },
  schedule: { label: "Programada", color: "#8E24AA", Icon: ScheduleIcon },
  opportunity: { label: "Negócio", color: "#1976D2", Icon: TrendingUpIcon },
};

const useStyles = makeStyles((theme) => ({
  list: {
    position: "relative",
    paddingLeft: 8,
  },
  item: {
    display: "flex",
    gap: 12,
    paddingBottom: 20,
    position: "relative",
  },
  iconCol: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  iconCircle: {
    width: 34,
    height: 34,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    flexShrink: 0,
    zIndex: 1,
  },
  line: {
    flex: 1,
    width: 2,
    backgroundColor: theme.palette.divider,
    marginTop: 4,
  },
  content: {
    flex: 1,
    paddingTop: 4,
  },
  clickable: {
    cursor: "pointer",
  },
  title: {
    fontWeight: 600,
  },
  description: {
    color: theme.palette.text.secondary,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
  date: {
    color: theme.palette.text.secondary,
    fontSize: 12,
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
  },
}));

const formatDate = (value) => {
  if (!value) return "";
  try {
    return new Date(value).toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch (e) {
    return "";
  }
};

const ContactTimeline = ({ events = [] }) => {
  const classes = useStyles();
  const history = useHistory();

  if (!events.length) {
    return (
      <Typography
        variant="body2"
        color="textSecondary"
        style={{ padding: 16, textAlign: "center" }}
      >
        Nenhum registro no histórico deste contato ainda.
      </Typography>
    );
  }

  return (
    <div className={classes.list}>
      {events.map((event, index) => {
        const config = typeConfig[event.type] || typeConfig.note;
        const { Icon } = config;
        const isLast = index === events.length - 1;
        const clickable = Boolean(event.link);

        return (
          <div className={classes.item} key={event.id}>
            <div className={classes.iconCol}>
              <span
                className={classes.iconCircle}
                style={{ backgroundColor: config.color }}
              >
                <Icon fontSize="small" />
              </span>
              {!isLast && <span className={classes.line} />}
            </div>
            <div
              className={`${classes.content} ${
                clickable ? classes.clickable : ""
              }`}
              onClick={() => clickable && history.push(event.link)}
            >
              <div className={classes.headerRow}>
                <Typography variant="body1" className={classes.title}>
                  {event.title}
                </Typography>
                {event.status && (
                  <Chip
                    size="small"
                    label={event.status}
                    style={{ height: 20, fontSize: 11 }}
                  />
                )}
              </div>
              <Typography className={classes.date}>
                {config.label} • {formatDate(event.date)}
              </Typography>
              {event.description && (
                <Typography variant="body2" className={classes.description}>
                  {event.description}
                </Typography>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ContactTimeline;
